const { client, loadToken } = require('./client');

export { loadToken };
// --- Content Repository API Calls ---

export async function createFolder(name, parentId = null) {
    var { data } = await client.post('/content', { name, type: 'folder', parentId });
    return data;
}

export async function saveFormSnippet(name, formData, parentId = null) {
    var { data } = await client.post('/content', { name, type: 'form', formData, parentId });
    return data;
}

export async function uploadImage(file, parentId = null, config) {
    const formData = new FormData();
    formData.append('file', file);
    if (parentId) formData.append('parentId', parentId);

    // The client (like Axios) will usually auto-detect FormData and set the correct multipart/form-data headers
    var { data } = await client.post('/content/upload', formData, {
        ...config
    });
    return data;
}

export async function moveContent(contentId, newParentId) {
    var { data } = await client.put(`/content/${contentId}/move`, { newParentId });
    return data;
}

export async function deleteContent(contentId) {
    var { data } = await client.delete(`/content/${contentId}`);
    return data;
}

export async function getContentTree() {
    var { data } = await client.get('/content/tree');
    return data;
}

// --- Campaign API Calls ---

export async function createCampaign(campaignData) {
    var { data } = await client.post('/campaigns', campaignData);
    return data;
}

export async function saveCampaign(id, data) {
    var { data } = await client.put(`/campaigns/${id}`, data);
    return data;
}

export async function getCampaign(id) {
    var { data } = await client.get(`/campaigns/${id}`);
    return data;
}

export async function getAllCampaigns(campaignData) {
    var { data } = await client.get('/campaigns', campaignData);
    return data;
}

export async function getCampaignTypes(campaignData) {
    var { data } = await client.get('/campaigns/types', campaignData);
    return data;
}

export async function getCampaigns(start_time, end_time) {
    var { data } = await client.get(`/campaigns/start/${start_time}/end/${end_time}`);
    return data;
}

export async function toggleCampaignStatus(id) {
    // Assuming you have an client instance or fetch wrapper set up
    const response = await client.put(`/campaigns/${id}/toggle-status`);
    return response.data;
};

export async function deleteCampaign(id) {
    const response = await client.delete(`/campaigns/${id}`);
    return response.data;
};

// GROUPS ADDITION
export async function findCampaignsByDeviceFilterValue(filter_id) {
    const response = await client.get(`/campaigns/filter/${filter_id}`)
    return response.data;
};

// --- Aggregation & Export ---

// --- Content Repository API Calls ---

export async function getContentFile(contentId) {
    var { data } = await client.get(`/content/${contentId}/file`);
    return data;
}

// Add it to your exports:
const all = {
    loadToken,
    createFolder,
    saveFormSnippet,
    uploadImage,
    moveContent,
    getContentTree,
    createCampaign,
    saveCampaign,
    getCampaigns,
    getAllCampaigns,
    getContentFile,
    getCampaignTypes,
    getCampaign,
    deleteContent,
    toggleCampaignStatus,
    deleteCampaign,
    findCampaignsByDeviceFilterValue
};

export default all;